import React from 'react';
import { 
    Edit, 
    SimpleForm, 
    TextInput, 
    SelectInput,
    BooleanInput,
    required,
    email,
    usePermissions
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";
import { processPermissions } from "../../common/roleUtils";

export const BranchEdit = props => {
    const { permissions } = usePermissions();
    let propsObj = { ...props };
    
    if (permissions) {
        // Use utility function to process permissions with role-based restrictions
        const processedPermissions = processPermissions(permissions, props.resource);
        propsObj = { ...propsObj, ...processedPermissions };
    }
    
    return (
        <React.Fragment>
            <Edit label="Edit Branch" {...propsObj}>
                <SimpleForm toolbar={<FormToolbar {...propsObj} hasDelete={true}/>}>
                    <TextInput 
                        source="branch_code" 
                        label='Branch Code' 
                        fullWidth={true} 
                        validate={[required()]} 
                        helperText="Unique code for the branch"
                    />
                    <TextInput 
                        source="branch_name" 
                        label='Branch Name' 
                        fullWidth={true} 
                        validate={[required()]} 
                    />
                    <SelectInput 
                        source="city" 
                        label="City" 
                        choices={[
                            { id: 'AJMER', name: 'Ajmer' },
                            { id: 'BHILWARA', name: 'Bhilwara' },
                            { id: 'BEAWAR', name: 'Beawar' },
                            { id: 'PARBATSAR', name: 'Parbatsar' },
                        ]} 
                        validate={[required()]} 
                    />
                    <TextInput 
                        source="address" 
                        label='Address' 
                        fullWidth={true} 
                        multiline 
                        rows={3}
                    />
                    <TextInput 
                        source="mobile_number" 
                        label='Contact Phone' 
                        fullWidth={true} 
                    />
                    <TextInput 
                        source="email" 
                        label='Contact Email' 
                        fullWidth={true} 
                        validate={[email()]}
                    />
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                    />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
}
